import initReviews from "components/jiffy/reviews-list/reviews-list";
import initReviewSummary from "components/jiffy/review-summary/review-summary";
import initProductReviewsControls from "components/jiffy/product-reviews-controls/product-reviews-controls";
import "./reviews-page.scss";
import "./reviews-page-reviews-title/reviews-page-reviews-title.scss";

export default () => {
  initReviews();
  initReviewSummary();
  initProductReviewsControls();
};
